/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Matching_Score_Category_Language_SkillsInputs */

const en_matching_score_category_language_skills = /** @type {(inputs: Matching_Score_Category_Language_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Language skills`)
};

const de_matching_score_category_language_skills = /** @type {(inputs: Matching_Score_Category_Language_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprachkenntnisse`)
};

/**
* | output |
* | --- |
* | "Language skills" |
*
* @param {Matching_Score_Category_Language_SkillsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const matching_score_category_language_skills = /** @type {((inputs?: Matching_Score_Category_Language_SkillsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Matching_Score_Category_Language_SkillsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_matching_score_category_language_skills(inputs)
	return en_matching_score_category_language_skills(inputs)
});